import { lazy } from 'react'

import i18n from 'modules/core/lib/i18n'
import { buildModuleRoute, buildNavigation } from 'modules/core/lib/react-router'

import groupsRoutes from 'modules/posts/routes/groups'
import npsRoutes from 'modules/posts/routes/nps'

import postDashboardRoutes from './postsDashboard'

const CompanyLinksEditPage = lazy(() => import('modules/dashboard/pages/CompanyLinksEditPage'))
const RootPage = lazy(() => import('modules/dashboard/pages/RootPage'))
const HomePage = lazy(() => import('modules/dashboard/pages/HomePage'))

export const dashboardRoutes = buildNavigation((navigation) => {
  return [
    buildModuleRoute({
      path: navigation.dashboard.path,
      element: <RootPage />,
      handle: {
        module: 'home',
        moduleName: () => i18n.t('sidebar.dashboard'),
        meta: () => ({
          title: i18n.t('sidebar.dashboard'),
        }),
      },
      children: [
        {
          path: '',
          element: <HomePage />,
          children: [
            {
              path: navigation.dashboard.companyLinksEdit.path,
              element: <CompanyLinksEditPage />,
            },
            ...groupsRoutes(navigation),
          ],
        },
        // TODO: this should be included in the HomePage as children so the modal is rendered correctly.
        //       However, there is some re-render bug that makes it worse.
        ...postDashboardRoutes(navigation),
        ...npsRoutes(navigation),
      ],
    }),
  ]
})
